import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../../js/app/react/validators';

import View from './TaxesLocationView';

import {
  currentClientId,
  data2,
  iterator,
  data as dataSelector,
  isGoingForwardSelector,
  isPopulatedSelector,
  taxLocationsSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../TaxesWorkflowConstants';
import { updateData, updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { taxLocationGroups } from '../../../CommonUtils/taxLocations';

export const mapStateToProps = (state, ownProps) => ({
  iterator: iterator(state, ownProps),
  clientId: currentClientId(state, ownProps),
  taxesLocation: data2(state, ownProps)(`${BACKEND_KEY}.Taxes.FilingState`),
  serverTaxesLocation: dataSelector(state, ownProps)(`${BACKEND_KEY}.Taxes.FilingState`),
  taxesLocationOptions: taxLocationsSelector(state),
  taxesLocationGroups: taxLocationGroups,
  hasFamily:
    data2(state, ownProps)(`${BACKEND_KEY}.HasPartner`) ||
    data2(state, ownProps)(`${BACKEND_KEY}.HasChildren`),
  hasPartner: data2(state, ownProps)(`${BACKEND_KEY}.HasPartner`),
  isGoingForward: isGoingForwardSelector(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
});
export const mapDispatchToProps = dispatch => ({
  preprocessData: (clientId, serverTaxesLocation, store2) => {
    if (serverTaxesLocation) {
      store2(
        {
          [BACKEND_KEY]: {
            Taxes: {
              FilingState: serverTaxesLocation,
            },
          },
        },
        clientId,
      );
    }
  },
  store: workflowId => (data, clientId) => {
    dispatch(updateData(data, workflowId, clientId));
  },
  store2: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
});

const TaxesLocationContainer = connect(mapStateToProps, mapDispatchToProps)(View);
TaxesLocationContainer.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired),
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default TaxesLocationContainer;
